;(function (root, _) {
  'use strict'

  // @todo <jordan@workwithopal.com> I18n
  var knownPatterns = {
    '\\d': {
      description: 'a digit',
      matcher: /\\d/,
    },
    '\\W': {
      description: 'a symbol',
      matcher: /\\W/,
    },
    'a-z': {
      description: 'a lowercase letter',
      matcher: /a-z/,
    },
    'A-Z': {
      description: 'an uppercase letter',
      matcher: /A-Z/,
    },
  }

  /**
   * Ensure that the patterns are a list of strings.
   *
   * @param {(string|Array<string>)} rawPatterns - The regular expressions to humanize.
   * @returns {Array<string>} The formatted regular expressions.
   *
   * @access private
   */
  function prepareRegExps(rawPatterns) {
    var patterns = !Array.isArray(rawPatterns) ? [rawPatterns] : rawPatterns

    var mapped = patterns.map(function (pattern) {
      return _.isRegExp(pattern) ? pattern.source : pattern
    })

    return mapped
  }

  /**
   * Generate the humanized text for a given regular expression.
   *
   * @param {string} pattern - The regular expression to parse.
   * @returns {string} The parsed regular expression.
   *
   * @access private
   * @todo <jordan@workwithopal.com> I18n
   */
  function parseRegExp(pattern) {
    var matchedPatterns = _.chain(knownPatterns)
      .filter(function (knownPattern) {
        return knownPattern.matcher.test(pattern)
      })
      .value()

    return matchedPatterns
      .map(function (matchedPattern) {
        return matchedPattern.description
      })
      .join(' or ')
  }

  /**
   * Humanize a list of regular expressions.
   *
   * @param {(string|Array<string>)} patterns - The regular expressions to humanize.
   * @returns {Array<string>} The humanized regular expressions.
   *
   * @example
   *   humanizeRegExp([/\d/, '[A-Z]'])
   *   //=> ['a digit', 'an uppercase letter']
   *
   * @access public
   */
  function humanizeRegExp(patterns) {
    var preparedPatterns = prepareRegExps(patterns)

    var parsed = preparedPatterns.map(function (pattern) {
      return parseRegExp(pattern)
    })

    return _.compact(parsed)
  }
  root.humanizeRegExp = humanizeRegExp
})(window, _)
